import React from 'react';

const SVG = ({ style = {}, color, width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <path fill={color} d="M25,2 H75 V40 H97 V99 H3 V40 H25" />
    <g fill="none" stroke="white" strokeWidth="5">
      <rect x="4" y="40" width="92" height="57" />
      <rect x="25" y="2.5" width="50" height="37" />
      <line x1="27" y1="72" x2="27" y2="99" />
      <line x1="73" y1="72" x2="73" y2="99" />
    </g>
  </svg>
);

export default SVG;
